import { getQueryParam } from '../../routing/getQueryParam';
import { getIsVerifiedByGoogleCredential } from '../../store/app/selectors';
export const getIsGoogleCredentialAuthentication = state => {
  const googleAuthenticationCredential = getQueryParam('googleAuthenticationCredential');
  return Boolean(googleAuthenticationCredential) || getIsVerifiedByGoogleCredential(state);
};